import { render, staticRenderFns } from "./jtjh-pdf.vue?vue&type=template&id=55c81174&"
import script from "./jtjh-pdf.vue?vue&type=script&lang=js&"
export * from "./jtjh-pdf.vue?vue&type=script&lang=js&"
import style0 from "./jtjh-pdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports